import * as React from 'react';
import { SVGProps } from 'react';
const SaveIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <g strokeLinecap="round" strokeLinejoin="round" clipPath="url(#a)">
      <path d="M18.667 16H9.334M14.666 12l4 4-4 4M22.666 20v-8" />
      <path d="M7.515 7.515c4.686-4.687 12.284-4.687 16.97 0 4.687 4.686 4.687 12.284 0 16.97-4.686 4.687-12.284 4.687-16.97 0-4.687-4.686-4.687-12.284 0-16.97Z" />
    </g>
  </svg>
);
export default SaveIcon;
